import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

export function useMainAgreement() {
  const client = useApiClientUser()

  const getMainAgreement = async () => {
    const resp = await client.user.onboardingControllerGetMainAgreement({
      secure: true,
    })
    return resp.data.agreementPreview
  }

  const {
    error,
    isLoading,
    data: agreement,
  } = useQuery({
    queryKey: ['mainAgreement'],
    queryFn: getMainAgreement,
  })

  const errorMessage = getApiErrorMessage(
    error,
    'Zmluvu sa nepodarilo načítať.'
  )

  return {
    error: errorMessage,
    isLoading,
    agreement,
  }
}
